<template>
  <div class="check-boxes">
    <CheckBox v-for="item in list" :key="item.key" :value="item.key" :checked="checkedKeys" @change="onChange">{{
      item.label
    }}</CheckBox>
  </div>
</template>

<script>
import { isMap } from 'lodash'
import CheckBox from '@/components/atoms/CheckBox'

/**
 * 複数チェック
 */
export default {
  name: 'CheckBoxes',
  components: {
    CheckBox,
  },
  model: {
    prop: 'checkedKeys',
    event: 'change',
  },
  props: {
    /** 選択肢 */
    items: { type: [Array, Object, Map], required: true },
    /** 選択中のキー */
    checkedKeys: { type: Array, default: () => [] },
  },
  computed: {
    list() {
      if (isMap(this.items)) return Array.from(this.items).map(([key, label]) => ({ key, label }))
      if (this.items instanceof Array) return this.items.map((value, index) => ({ key: index, label: value }))
      return Object.keys(this.items).map(key => ({ key, label: this.items[key] }))
    },
  },
  methods: {
    onChange(keys) {
      this.$emit('change', keys)
    },
  },
}
</script>

<style lang="postcss" scoped>
.check-boxes {
  display: grid;
  grid-auto-flow: column;
  grid-gap: 8px;
  justify-content: flex-start;
}
</style>
